import 'owl.carousel/dist/assets/owl.carousel.min.css';
import 'owl.carousel';


if ($('.interactive-slider').length != 0) {
    if ($(window).width() > 991) {
        $('.interactive-slider').owlCarousel({
            items: 1,
            mouseDrag: true,
            nav: false,
            dots: true,
            navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><use xlink:href="/img/svg/common.svg#svg_interaktiv_arrow_right"></use></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><use xlink:href="/img/svg/common.svg#svg_interaktiv_arrow_right"></use></svg>'],
            startPosition: 0,
            onChanged: itemIndex,
            responsiveClass: true,
            slideBy: 1,
            lazyLoad: true,
            onInitialized: loadLazyImages, // Загрузить активные изображения при инициализации
            onTranslated: loadLazyImages,   // Подгружать изображения при смене слайда
            responsive: {
                991: {
                    items: 1,
                    slideBy: 1,
                    nav: true
                }
            }

        });
    } else {
        $('.img-wrapper').each(function (i, el) {
            $('<div class="slider-item slider-item_mobile zoom-img"><div class="zoom-wrapper"></div></div>').appendTo('.interactive-slider_mobile');
            let currentSlider = $('.slider-item_mobile')[i];
            let wrapper = $(currentSlider).find('.zoom-wrapper')
            $(el).clone().appendTo($(wrapper))
        })
        $('.interactive-slider_mobile').owlCarousel({
            items: 1,
            mouseDrag: true,
            nav: false,
            dots: true,
            navHtml: ["", ""],
            startPosition: 0,
            onChanged: itemIndex,
            responsiveClass: true,
            slideBy: 1,
            lazyLoad: true,
            onInitialized: loadLazyImages, // Загрузить активные изображения при инициализации
            onTranslated: loadLazyImages   // Подгружать изображения при смене слайда
        });
        
    }



    function addOptions() { //сгенерить выпадающий список в навигации
        let options = $(".interactive-slider .owl-dots button");
        let page1 = 0;
        let page2 = 1;

        options.each(function (index, el) {

            if ($(window).width() > 991) {
                $("<option>").text(page1 + '-' + page2).val(index).appendTo('#pages');
                page1 += 2
                page2 += 2
            } else {
                $("<option>").text(page1).val(index).appendTo('#pages');
                page1 += 1
                page2 += 1
            }
        })

    }

    let korzinki = $('.dropdown');
    korzinki.each(function (index, el) {  //корзинки выпадают вправо если left > 50%
        let elementLeftPosition = $(el).get(0).style.left
        if (parseInt(elementLeftPosition) > 50) {
            $(el).addClass('dropleft');
        }
    })
    korzinki.on("show.bs.dropdown", function () {
        $(this).css('z-index', '3')
    })
    korzinki.on("hide.bs.dropdown", function () {
        $(this).css('z-index', '2')
    })



    $("#pages").val(0);  // Установить в select значение первой страницы


    function itemIndex(event) {
        let elem = event.target;
        let dotIndex = $(elem).find('.owl-dots button.active').index()
        $("#pages").val(dotIndex);  //При смене слайда изменить значение в select
    }
    $(".skip-start").on('click', function(e){
        $('.interactive-slider').trigger('to.owl.carousel', [0, 0]); //в конец карусели
    });
    $(".skip-end").on('click', function(e){
        $('.interactive-slider').trigger('to.owl.carousel', [-1, 0]); //в конец карусели
    });

    $("#pages").on('change', function () {
        let num = $(this).prop('selectedIndex');  //номер выбранного select-a
        $('.interactive-slider').trigger('to.owl.carousel', [num, 0]); //перелистать до выбранного слайда
    })
    addOptions();


    let x;
    let y;
    let imgBlock = $('.zoom-wrapper');
    let xcenter = imgBlock.offset().left + imgBlock.width() / 2;
    let ycenter = imgBlock.offset().top + imgBlock.height() / 2;

    imgBlock.mousedown(function (e) {
        x = e.pageX
        y = e.pageY
    })

    if ($(window).width() > 991) {  //zoom on desktop
        imgBlock.mouseup(function (e) {

            if ($(e.target).is('img')) {

                if (x == e.pageX && y == e.pageY) {
                    if ($(this).hasClass('zoom_in')) {
                        $(this).removeClass('zoom_in').addClass('zoom_out')
                        let sliderItem = $(this).closest('.zoom-img')
                        $(this).addClass('img-scale')

                        let offsetX = xcenter - e.pageX + 'px';
                        let offsetY = ycenter - e.pageY + 'px'

                        $(this).css({
                            'transform': 'translate(' + offsetX + ',' + offsetY + ') scale(2)',
                        })

                        zoom(sliderItem)
                    } else if ($(this).hasClass('zoom_out')) {
                        $(this).removeClass('zoom_out').addClass('zoom_in');
                        $(this).removeClass('img-scale')
                        let sliderItem = $(this).closest('.zoom-img')
                        $(this).css({
                            'transform': 'translate(0, 0) scale(1)',
                        })
                        zoomDestroy(sliderItem)
                    }
                }
            }
        })
    } else {                        //zoom on mobile

        var scaling = false;
        var dist = 0;
        var scale_factor = 1.0;
        var curr_scale = 1.0;
        var max_zoom = 5.0;
        var min_zoom = 1;
        let currentPositionTop,
            currentPositionLeft,
            lastTap = 0,
            pos,
            Xcursor,
            Ycursor,
            offsetY,
            offsetX,
            img,
            container = $('.interactive-body');

        let zoomOut = false;
        let fingerOnDisplay = false;

        /*функция, которая определяет расстояние между пальцами*/
        function distance(p1, p2) {
            return (Math.sqrt(Math.pow((p1.clientX - p2.clientX), 2) + Math.pow((p1.clientY - p2.clientY), 2)));
        }

        /*Ловим начало косания*/
        imgBlock.on('touchstart', function (e) {
            fingerOnDisplay = true;
            if (curr_scale > 1) {
                e.preventDefault();
                e.stopPropagation()
                img = $(this);


                currentPositionTop = img.offset().top;
                currentPositionLeft = img.offset().left;
                pos = img.offset()
                Xcursor = e.touches[0].pageX - pos.left;
                Ycursor = e.touches[0].pageY - pos.top;

            }
            let tt = e.targetTouches;

            if (tt.length >= 2) {
                e.preventDefault();
                e.stopPropagation();
                dist = distance(tt[0], tt[1]);
                scaling = true;
                twoFinger = true;
            } else {
                scaling = false;
                //отследить 2 клика и увеличить картинку
                var currentTime = new Date().getTime();
                var tapLength = currentTime - lastTap;
                lastTap = currentTime;
                if (tapLength < 300 && tapLength > 0) {  //двойной тап

                    if (curr_scale == 1.0) { //увеличить масштаб
                        curr_scale = 2;
                        $(this).css({
                            'transform': "scale(" + curr_scale + ", " + curr_scale + ")"
                        })
                        scaling = true;

                    } else {                 //уменьшить масштаб
                        curr_scale = 1.0;
                        $(this).css({
                            'transform': "scale(" + curr_scale + ", " + curr_scale + ")"
                        })
                    }

                }
            }

        })
        /*Ловим зумирование*/

        imgBlock.on('touchmove', function (e) {
            let tt = e.targetTouches;
            // $('#console').text(tt.length) 
            if (tt.length >= 2) {
                e.preventDefault();
                e.stopPropagation();

            }
            if (curr_scale > 1) {
                e.stopPropagation();

                if (tt.length == 1 && fingerOnDisplay) {

                    offsetY = (e.touches[0].pageY - pos.top) - Ycursor
                    offsetX = (e.touches[0].pageX - pos.left) - Xcursor
                    let top = currentPositionTop + offsetY;
                    let left = currentPositionLeft + offsetX;

                    if ($(this).position().top > 0 && offsetY > 0) {
                        top = $(this).offset().top;
                    }
                    if ($(this).position().left > 0 && offsetX > 0) {
                        left = $(this).offset().left;
                    }
                    if ($(this).position().left + ($(this).width() * curr_scale) < container.width() && offsetX < 0) {
                        left = $(this).offset().left;
                    }
                    if ($(this).position().top + ($(this).height() * curr_scale) < container.outerHeight() && offsetY < 0) {
                        top = $(this).offset().top;
                    }
                    img.offset({ top: top, left: left })

                }
            }
            if (scaling) {
                curr_scale = distance(tt[0], tt[1]) / dist * scale_factor;

                if (curr_scale < 1) {
                    curr_scale = 1.0
                }
                if (curr_scale < 3) {
                    $(this).css({
                        'transform': "scale(" + curr_scale + ", " + curr_scale + ")"
                    })

                } else {
                    curr_scale = 3;
                }
                if (distance(tt[0], tt[1]) < dist) {
                    zoomOut = true
                } else {
                    zoomOut = false
                }


            }
        })
        /*Ловим конец косания*/
        imgBlock.on('touchend', function (e) {
            fingerOnDisplay = false;

            if (curr_scale < min_zoom) {
                scale_factor = min_zoom;
            } else {
                if (curr_scale > max_zoom) {
                    scale_factor = max_zoom;
                } else {
                    scale_factor = curr_scale;
                }
            }
            if (zoomOut) {
                zoomOut = false
                if ($(this).position().top > 0) {

                    $(this).offset({ top: 153 })
                }
                if ($(this).position().left > 0) {

                    let leftPosition = container.offset().left
                    $(this).offset({ left: leftPosition })
                }
                if ($(this).position().left + ($(this).width() * curr_scale) < container.width()) {
                    let elWidth = $(this).position().left + ($(this).width() * curr_scale);
                    let containerRight = container.outerWidth();
                    let currentOffsetLeft = $(this).offset().left;
                    let newOffsetLeft = currentOffsetLeft + (containerRight - elWidth)
                    $(this).offset({ left: newOffsetLeft })

                }
                if ($(this).position().top + ($(this).height() * curr_scale) < container.outerHeight()) {

                    let elHeight = $(this).position().top + ($(this).height() * curr_scale)
                    let containerBottom = container.outerHeight()
                    let currentOffsetTop = $(this).offset().top;
                    let newOffsetTop = currentOffsetTop + (containerBottom - elHeight)
                    $(this).offset({ top: newOffsetTop })

                }
            }

            $(this).css({
                'transform': "scale(" + scale_factor + ", " + scale_factor + ")",
            })



            if (curr_scale <= 1) {
                $(this).css({
                    'transform': "scale(1, 1)",
                    'left': 0,
                    'top': 0
                })
            }
        })
    }


    $('.interactive-slider_mobile').on('change.owl.carousel', function (event) {
        imgBlock.css({
            'transform': "scale(1, 1)",
            'left': 0,
            'top': 0
        })
        scaling = false;
        dist = 0;
        scale_factor = 1.0;
        curr_scale = 1.0;
    })

    function zoom(el) {
        let down = false;
        let pos = $(el).offset();
        let img = $(el).find('.img-scale');
        if ($(window).width() > 991) {

            $(el).mousedown(function (e) {
                e.stopPropagation()
                e.preventDefault()
                let currentPositionTop = img.offset().top;
                let currentPositionLeft = img.offset().left;
                let Xcursor = e.pageX - pos.left;
                let Ycursor = e.pageY - pos.top;
                down = true;
                $(this).mousemove(function (e) {
                    e.stopPropagation()
                    if (down) {
                        let cursorY = (e.pageY - pos.top) - Ycursor
                        let cursorX = (e.pageX - pos.left) - Xcursor
                        img.offset(function (i, coord) {
                            var newCoord = {};
                            newCoord.top = currentPositionTop + cursorY;
                            newCoord.left = currentPositionLeft + cursorX;
                            return newCoord;
                        });
                    }
                })
            });
            $(el).mouseup(function (e) {
                down = false;
            })
        }

    }
    function zoomDestroy(el) {
        $(el).unbind();
        let img = $(el).find('.zoom-wrapper');
        img.css({
            "top": '0',
            "left": '0'
        })

    }
}

function loadLazyImages(event) {
    // Находим активные элементы <picture> и подгружаем их изображения
    $(event.target).find('.owl-item.active picture.lazy-picture').each(function() {
        
        // Подгрузка <source> в <picture>
        $(this).find('source').each(function() {
            let srcset = $(this).data('srcset');
            if (srcset && !$(this).attr('srcset')) {
                $(this).attr('srcset', srcset);
            }
        });
        
        // Подгрузка <img> в <picture>
        let img = $(this).find('img');
        let src = img.data('src');
        if (src && !img.attr('src')) {
            img.attr('src', src);
            img.addClass('fade-in'); // Дополнительно: добавляем класс для анимации появления, если требуется
        }
    });
}